import { usePatentListFilterValue } from "@stores/patentList";

import { PatentOrderingKey, PatentOrderingValue } from "../Patent.types";

export const useGetPatentListFilterData = () => {
  const patentListFilter = usePatentListFilterValue();
  const {
    search,
    page,
    pageLimit,
    status,
    order,
    primaryCategory,
    drugProfileExtractable,
  } = patentListFilter;

  const updateOrder = Object.entries(order).map(
    ([key, value]): {
      sortBy: PatentOrderingKey;
      sortOrder: PatentOrderingValue;
    } => ({
      sortBy: key as PatentOrderingKey,
      sortOrder: value as unknown as PatentOrderingValue,
    }),
  );

  const patentListFilterListForUpdate = {
    page,
    size: pageLimit,
    filter: {
      primaryCategory,
      // Extractable 체크박스: 체크 시에만 true 전송, 미선택이면 미전송(전체 보기)
      ...(drugProfileExtractable && { drugProfileExtractable: true }),
      draftArticleStatusHighest: status,
      ...(search && {
        search: Object.entries(search)
          .filter(([, value]) => value && value.trim() !== "")
          .map(([key, value]) => ({
            type: key,
            keyword: value,
          })),
      }),
    },
    order: [...updateOrder],
  };

  return patentListFilterListForUpdate;
};
